<template>
    <ContentOrLoading>
        <MainContent title="Editar compañia" v-if="!loading">
            <template v-slot:header>
                <h3 class="card-title">Editar compañia</h3>
            </template>
            <template v-slot:content>
                <FormComponent
                    :compania="compania"
                    :error="error"
                    @terminado="editarCompania()"
                    @imagenBorrada="{ error = null }"
                />
            </template>
        </MainContent>
    </ContentOrLoading>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/compania-eventos/FormComponent.vue';

    export default {
        data() {
            return {
                loading: false,
                compania: null,
                error: null
            }
        },
        created() {
            this.getCompania();
        },
        methods: {
            getCompania() {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    company_id: this.compania_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.show'), params).then(res => {
                    this.compania = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            editarCompania() {
                this.loading = true;
                this.compania.company_id = this.compania.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.editar'), this.compania).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.compania-eventos.index' });
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                    this.error = error.response?.data?.errors?.imagen[0];
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            compania_id() {
                return this.$route.params.compania_id;
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>